import {announce} from '@github-ui/aria-live'
import {observe} from '@github-ui/selector-observer'

// pass in a string instead and use announce
observe('.js-starred-repos-search-results', function (el) {
  setTimeout(() => {
    announce(el.textContent || '')
  }, 500)
})
